export const LINKED_SERVICES_TYPES: any = ["sql", "file", "api"];

export const LINKED_SERVICES_SUBTYPES: any = {
  sql: [
    "mariadb",
    "azure_sql",
    "oracle_sql",
    "snowflake_sql",
    "postgres_sql",
    "azure_sql_service_principal",
  ],
  file: ["local", "blob", "sftp"],
  api: [
    "no_auth_api",
    "basic_auth_api",
    "token_auth_api",
    "key_auth_api",
    "oauth_api",
  ],
};
